import { PetCostsPage } from '@web/components/pet-costs-page';
import { PetCostsScreenProps } from 'shared/screens/pet-costs';
import { withServerProps } from '@web/library/with-server-props';

export default function CatCosts(props: PetCostsScreenProps) {
  return <PetCostsPage {...props} animal={'cat'} />;
}

export const getServerSideProps = withServerProps();
